export default function AdminComingSoon({ title, desc }: { title: string; desc: string }) {
  return (
    <div className="Main-cover admin-panel">
      <div className="admin-panel-header">
        <h2 className="admin-panel-title">{title}</h2>
        <p className="admin-panel-desc">{desc}</p>
      </div>
      <div className="admin-state">🚧 준비중입니다.</div>
    </div>
  );
}
